/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getRequestDrugPriceLoadManufactureList,
  getRequestDrugPriceLoadValidateFrozenInvoice,
  setMFGTableData,
  setPriceLoadDetailsFilter,
  setPriceLoadDetailsLoaded,
  setRequestPriceLoadSearchFilter,
  setPriceLoadDetailsChanged
} from '../store/action';
import {
  multiPriceSelectionRadioData,
  validateHeaderFields,
} from '../utils/constant';
import { REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_HEAD } from '../utils/tableHead';

export const checkQuaterIsValid = (quater) => {
  if (quater?.includes('Q')) {
    const splitYear = quater.split('Q');
    const checkQuater = splitYear[0] <= 4;
    if (
      checkQuater &&
      splitYear.length === 2 &&
      splitYear[0].length === 1 &&
      (splitYear[1].length === 2 || splitYear[1].length === 4)
    ) {
      return true;
    }
    return false;
  }
  return false;
};

const RequestDrugPriceLoadManufactureTable = ({
  searchFilter,
  fullScreen,
  setFullScreen,
  setErrorMessages,
  navigateToPage,
  setFieldError,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const childRef = useRef(null);
  const [gridApi, setGridApi] = useState(null);
  const [columnApi, setColumnApi] = useState(null);
  const [applyFilter, setApplyFilter] = useState(false);
  const [tableCount, setTableCount] = useState(0);
  const [rowData, setRowData] = useState(null);
  const [shouldFetchData, setShouldFetchData] = useState(false);

  const priceLoadMFGData = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadMFGData
  );
  useEffect(() => {
    if (searchFilter.planType) {
      let error = [];
      let errorObj = {};

      const { error: headerError, errorObj: headerErrorObj } =
        validateHeaderFields(searchFilter, '');

      error = headerError;
      errorObj = headerErrorObj;

      if (error && error.length > 0) {
        if (searchFilter.rpc != null || searchFilter.priceType != null) {
          setFieldError(errorObj);
          setErrorMessages(error);
        }

        setRowData(null);
        dispatch(setMFGTableData([]));
      } else {
        setFieldError(null);
        setErrorMessages([]);
        setShouldFetchData(true)
      }
    }
  }, [searchFilter]);
  React.useEffect(()=>{
    if(shouldFetchData){
      dispatch(
        getRequestDrugPriceLoadManufactureList({
          ...searchFilter,
          planType:
            searchFilter.planType === 'ST' || searchFilter.planType === 'FD'
              ? 'G'
              : 'C',
          priceType: searchFilter.priceType
            ? [searchFilter.priceType]
            : [],
        })
      );
      setShouldFetchData(false)
    }
  },[shouldFetchData])

  useEffect(() => {
    return () => {
      setFieldError(null);
      setErrorMessages(null);
    };
  }, []);

  const onGridReady = useCallback((params) => {
    setGridApi(params.api);
    setColumnApi(params.columnApi);
    setTableCount(params.api.getDisplayedRowCount());
  }, []);

  useEffect(() => {
    resetFilters();

    setTableCount(gridApi && gridApi.getDisplayedRowCount());
  }, [gridApi, priceLoadMFGData]);

  const resetFilters = () => {
    setRowData(null);
    // gridApi && gridApi.deselectAll();
    // gridApi && gridApi.setFilterModel(null);
  };
  const handleFullScreenViewClick = () => {
    setFullScreen(!fullScreen);
  };
  const rowSelectedGrid = (rowData) => {
    dispatch(setPriceLoadDetailsLoaded(false));
    if (rowData) {
      dispatch(
        getRequestDrugPriceLoadValidateFrozenInvoice(
          {
            ...searchFilter,
            planType:
              searchFilter.planType === 'ST' || searchFilter.planType === 'FD'
                ? 'G'
                : 'C',
            mfgId: rowData.mfgId,
            mfgName: rowData.mfgName,
            mfgTypeCd: rowData.mfgTypeCd,
          },
          () => {
            setErrorMessages([]);
            dispatch(
              setPriceLoadDetailsFilter({
                ...searchFilter,
                planType:
                  searchFilter.planType === 'ST' ||
                  searchFilter.planType === 'FD'
                    ? 'G'
                    : 'C',
                mfgId: rowData.mfgId,
                mfgName: rowData.mfgName,
                mfgTypeCd: rowData.mfgTypeCd,
                multiPriceSelection: multiPriceSelectionRadioData[0].value,
              })
            );
            dispatch(setPriceLoadDetailsChanged(false));
            navigateToPage(
              '/RequestDrugPriceLoadDetails',
              'Invoice Drug Price Detail'
            );
          },
          (message) => {
            setErrorMessages([message]);
          }
        )
      );
    } else {
      setErrorMessages(['Please select manufacture to get details']);
    }
  };
  useEffect(() => {
  if (!gridApi || !priceLoadMFGData?.length) return;

  const selectedRows = gridApi.getSelectedRows();
  if (selectedRows.length > 0) return;

  const firstNode = gridApi.getDisplayedRowAtIndex(0);
  if (firstNode) {
    firstNode.setSelected(true);
    //rowSelectedGrid(firstNode.data); 
  }
}, [gridApi, priceLoadMFGData]);


  return (
    <div className='table-container p-0 eightRecords col-12 no-border mt-4'>
      <TableGridWithFeatures
        data-testid='DPL-cbi-table'
        fullScreenView={fullScreen}
        handleFullScreenViewClick={handleFullScreenViewClick}
        gridHeight={fullScreen ? '100vh' : 350}
        rowData={priceLoadMFGData}
        defaultCol={{ editable: false }}
        columnDefs={REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_HEAD}
        exportFile
        cellClickedListener={(e) => {
          rowSelectedGrid(e.data);
        }}
        sideBar={false}
        gridCall={onGridReady}
        onFilterChanged={(e) => {
          setTableCount(e.api.getDisplayedRowCount());
          if (
            (e.api.getFilterModel() && Object.keys(e.api.getFilterModel()))
              .length > 0
          ) {
            setApplyFilter(true);
          } else {
            setApplyFilter(false);
          }
        }}
        singleClickEdit={false}
        fileName='Invoice Drug Price Detail'
      />
    </div>
  );
};

export default RequestDrugPriceLoadManufactureTable;
